/* Accessori Detail — Fotorecord
   Gestisce tutte le istanze di "accessori-detail".
   Ascolta l'evento in data-accd-event; dati (materiale, colore, descrizione, note, sku)
   dal metaobject accessori_configuratore via payload configuratore. */

(function () {
  'use strict';

  function populateSection(root, detail) {
    var ph  = root.querySelector('.mdet-placeholder');
    var det = root.querySelector('.mdet-detail');
    if (!ph || !det) return;

    var totQty = detail
      ? (detail.tipo === 'clip' ? detail.clipQty : detail.totQty)
      : 0;

    if (!detail || !totQty) {
      ph.style.display  = '';
      det.style.display = 'none';
      return;
    }

    ph.style.display  = 'none';
    det.style.display = '';

    var q = function (sel) { return root.querySelector(sel); };
    // Valorizza la cella e nasconde l'intera riga se il dato manca
    var setRow = function (sel, text) {
      var el = q(sel);
      if (!el) return;
      el.textContent = text || '';
      var row = el.closest('.mdet-spec-row');
      if (row) row.style.display = text ? '' : 'none';
    };

    var badge = q('.mdet-badge');
    if (badge) {
      badge.textContent = detail.tipo === 'clip' ? 'Clip metalliche' : 'Attaccaglie';
      badge.className = 'mdet-badge';
    }

    /* Nome + codice pubblico nel nome (mirror di codice_prodotto.nome_cliente, 15/09/2026). */
    var core = window.FOTORECORD && window.FOTORECORD.core;
    var nomeEl = q('.mdet-nome');
    if (nomeEl) nomeEl.textContent = (core && core.nomeCliente) ? core.nomeCliente(detail.nomeBreve || detail.nome, detail.sku) : (detail.nome || '');

    setRow('.accd-val-materiale',   detail.materiale || '');
    setRow('.accd-val-colore',      detail.colore || '');
    setRow('.accd-val-descrizione', detail.descrizioneBreve || '');
    setRow('.accd-val-note',        detail.note || '');

    var img  = q('.mdet-media__img');
    var icon = q('.mdet-media__icon');
    if (img && icon) {
      if (detail.imgUrl) {
        img.src = detail.imgUrl; img.alt = detail.nome || ''; img.style.display = ''; icon.style.display = 'none';
      } else {
        img.style.display = 'none'; icon.style.display = '';
      }
    }
  }

  document.querySelectorAll('[data-accd-event]').forEach(function (root) {
    var eventName = root.dataset.accdEvent;
    var initKey   = root.dataset.accdInit;

    document.addEventListener(eventName, function (e) {
      populateSection(root, e.detail);
    });

    setTimeout(function () {
      if (initKey && window[initKey]) populateSection(root, window[initKey]);
    }, 0);
  });
})();
